import { useState } from 'react';
import _ from 'lodash';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import { userListData } from './data/userListData';
import { productListData } from './data/productListData';
import { formatNumber } from '../../utils/format';

import { ICON_LIST } from './constants';


const tableComponent = {
  dimension: ({ header, rowData }) => {
    const { id } = header;
    const value = _.get(rowData, id);

    return value ? value : '--';
  },
  metric: ({ header, rowData }) => {
    const { id, format } = header;

    return rowData[id] ? formatNumber(rowData[id], format || '#000') : '--'
  },
  action: ({ header, rowData, handleTableAction }) => {
    const { id, name, icon } = header;

    const IconComponent = ICON_LIST[icon];

    return (
      <>
        {
          ICON_LIST[icon] ? (
            <IconButton
              variant='main'
              onClick={(e) => {
                handleTableAction(e, {
                  id,
                  data: rowData
                })
              }}
              color={id === 'delete' ? 'error' : 'primary'}
            >
              <IconComponent />
            </IconButton>
          ) : (
            <Button
              variant="outlined"
              size="xs"
              onClick={(e) => {
                handleTableAction(e, {
                  id,
                  data: rowData
                })
              }}
            >{name}</Button>
          )
        }
      </>
    )
  },
}

const TableDataContent = (props) => {
  const {
    tableColumnsDefined,
    header,
    rowData,
    handleTableAction,
    handleOtherInfo
  } = props;
  const { type, render } = header;
  const [isDropDown, setIsDropDown] = useState(false);

  return (
    <>
      {
        !render
        && tableComponent[type]({ header, rowData, handleTableAction, handleOtherInfo, isDropDown, setIsDropDown })
      }
      {
        render && tableColumnsDefined.key === 'userList'
        && userListData[render.method]({ header, rowData, handleTableAction, handleOtherInfo, isDropDown, setIsDropDown })
      }
      {
        render && tableColumnsDefined.key === 'productList'
        && productListData[render.method]({ header, rowData, handleTableAction, handleOtherInfo, isDropDown, setIsDropDown })
      }
    </>
  )
}

export default TableDataContent;